// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".draggable-signature[data-v-eb40e45e] {\n  width: 150px;\n  height: 50px;\n  z-index: 1;\n  position: absolute;\n}", ""]);
// Exports
module.exports = exports;
